export const SessionRoutes = {
  login: '/session/login',
  requestDemo: '/session/demo',
  activate: '/session/activate',
  register: '/session/register',
  loginSife: '/session/login-sife',
  registerSife: '/session/register-sife',
};
